import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
// import TrainingAdvantages from "../components/TrainingAdvantages";
// import Chooseus from "../components/Chooseus";
// import OurImpact from "../components/OurImpact";
import TestimonialSection from "../components/TestimonialSection";
import EnrollSection from "../components/EnrollSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      {/* <TrainingAdvantages/> */}
      {/* <Chooseus/>
      <OurImpact/> */}
      <TestimonialSection/>
      <EnrollSection/>
    </>
  );
}